import { useQuery } from '@tanstack/react-query'
import { getBackupFiles } from '../utils/getBackupFiles'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useBackupFilesQuery = () => {
  const authedUser = useAuthStore((state) => state.user)
  return useQuery({
    queryKey: ['BACKUP_FILES', authedUser?._id as string],
    queryFn: getBackupFiles,
    enabled: !!authedUser,
  })
}
